import type { ElementType } from 'react';
import { KText } from '@/ui-library/components/text';
import {
  Center,
  Flex,
  Icon,
  Image,
  type FlexProps,
  type CenterProps,
  type ImageProps,
  type IconProps,
  type TextProps,
} from '@chakra-ui/react';
import { Plus } from '@kula-ai/icons-core';

export const IconButton = ({
  icon = Plus,
  text = 'Choose template',
  iconProps = {},
  iconContainerProps = {},
  textProps = {},
  isImageUrl = false,
  bg = 'secondary-50',
  ...props
}: {
  icon?: ElementType | string;
  text?: string;
  iconProps?: Partial<ImageProps & IconProps>;
  iconContainerProps?: CenterProps;
  textProps?: TextProps;
  isImageUrl?: boolean;
  bg?: string;
} & FlexProps) => {
  return (
    <Flex as="button" gap="6px" alignItems="center" {...props}>
      <Center
        width="20px"
        height="20px"
        borderRadius="full"
        bg={bg}
        {...iconContainerProps}
      >
        {icon &&
          (isImageUrl ? (
            <Image
              src={icon as string}
              width="8px"
              height="8px"
              objectFit="contain"
              {...iconProps}
            />
          ) : (
            <Icon
              as={icon as ElementType}
              color="primary-500"
              width="8px"
              height="8px"
              {...iconProps}
            />
          ))}
      </Center>
      <KText
        whiteSpace="nowrap"
        size="sm-medium"
        color="primary-500"
        {...textProps}
      >
        {text}
      </KText>
    </Flex>
  );
};
